export default __webpack_public_path__ + "static/media/Shaka_particle_final_14.6d49a28f.png";